import { render } from "./NewChip.vue?vue&type=template&id=d0a984d4&scoped=true"
import script from "./NewChip.vue?vue&type=script&lang=js"
export * from "./NewChip.vue?vue&type=script&lang=js"

import "./NewChip.vue?vue&type=style&index=0&id=d0a984d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a984d4"]])

export default __exports__